// extracted by mini-css-extract-plugin
export default {"theme-wrapper":"kxAcC","themeWrapper":"kxAcC","close-button":"_2SpxQ","closeButton":"_2SpxQ"};